<template>
  <v-select
    :items="items"
    item-text="label"
    item-value="deviceId"
    :loading="loading"
    :label="label"
    prepend-icon="$freshvue-video-input"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'InputSelectVideoInput',

  props: {
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('fresh-vue.InputSelectVideoInput.label')
      }
    }
  },

  data() {
    return {
      loading: null,
      items: []
    }
  },

  mounted() {
    this.initializeDevices()
  },

  methods: {
    initializeDevices() {
      navigator.mediaDevices
        .getUserMedia({ video: true, audio: true })
        .then(() => {
          return navigator.mediaDevices.enumerateDevices()
        })
        .then((devices) => {
          this.items = devices.filter((item) => item.kind === 'videoinput')
        })
    }
  }
}
</script>
